<template>
<div>
  Slack Callback
</div>
</template>

<script>
export default {
  name: 'SlackCallback',
  
  mounted () {
    window.axios.post('api/slack/callback', {
      code: this.$route.query.code,
    }).then(() => {
      this.$router.push('/dashboard/settings');
    });
  }
};
</script>

<style scoped>

</style>